export function getResponsiveMode(element) {

    return getComputedStyle(element).getPropertyValue('--mode').trim().replace(/"/g, '') ?? null;

}